import { openDB } from 'idb'
import { defineStore } from "pinia"

import { useRuntimeStore } from "@/store/runtime"



const base64StringSize = (base64String) => {
  const padding = (base64String.match(/=/g) || []).length
  return (base64String.length * 3 / 4) - padding
}


export const useFilesStore = defineStore('filesStore', () => {

  const runtimeStore = useRuntimeStore()

  // https://github.com/jakearchibald/idb#readme

  const say = (text) => {
    console.log("🥞 " + text)
}


  const userPk = runtimeStore?.session?.user?.pk

  let dbPromise = null

  const initDatabase = async () => {

    dbPromise = openDB(`db-${userPk}`, 3, {

      upgrade(db, oldVersion, newVersion, transaction) {
        let filesStore = null
        say("upgrade from version: ", oldVersion)
        switch (oldVersion) {
          case 0:
            filesStore = db.createObjectStore('files', {
              autoIncrement: true,  // The 'id' property of the object will be the key.
              keyPath: 'id',   // If it isn't explicitly set, create a value by auto incrementing.
            })

            // filesStore = transaction.objectStore("files");

            filesStore.createIndex('name', 'name', { unique: true })
            filesStore.createIndex('mimetype', 'mimetype', { unique: false })
            filesStore.createIndex('extension', 'extension', { unique: false })
            filesStore.createIndex('created_at', 'created_at', { unique: false })
            filesStore.createIndex('target_uuid', 'target_uuid', { unique: false })
            filesStore.createIndex('content', 'content', { unique: false })
            filesStore.createIndex('size', 'size', { unique: false })
            filesStore.createIndex('state', 'state', { unique: false }) // 0: null, 1: uploaded

          case 1:
            // Get the original object store, and create an index on it:
            // debugger
            // filesStore = transaction('files', 'readwrite');
            filesStore = transaction.objectStore("files");
            filesStore.createIndex('purpose', 'purpose', { unique: false })

          case 2:
            filesStore = transaction.objectStore('files')
            if (filesStore.indexNames.contains('content')) {
              filesStore.deleteIndex('content')
            }

        }
        say("upgraded to version: ", newVersion)

      }
    })

  }



  if (userPk) initDatabase()


  const get = async (key) => {
    return (await dbPromise).get('files', key)
  }
  const set = async (val) => {
    return (await dbPromise).put('files', val)
  }
  // const set = async (key, val) => {
  //   return (await dbPromise).put('files', val, key)
  // }
  const updatedSomeValues = async (key, someValues) => {
    // debugger
    const file = await get(key)

    for (const [key, value] of Object.entries(someValues)) {
      file[key] = value
      // console.log(key, value)
    }

    return set(file)

  }
  const del = async (key) => {
    return (await dbPromise).delete('files', key)
  }
  const clear = async () => {
    return (await dbPromise).clear('files')
  }
  const keys = async () => {
    return (await dbPromise).getAllKeys('files')
  }




  const add = async (value) => {
    // 
    console.log(value)
    value.size = base64StringSize(value.content)
    say("📐 size is " + value.size + " bytes")
    //    const now = new Date(Date.now()).valueOf()

    return await (await dbPromise).add('files', value)
  }


  const keysByFileType = async () => {
    // return (await dbPromise).transaction('files').objectStore('files').index('type').getAll(1)
  }

  const filterByObj = async (obj) => {
    const files = await allFilesWithoutContent()
    const keys = Object.keys(obj)
    return files.filter(file => {
      return keys.every(key => {
        return file[key] === obj[key]
      })
    })
  }


  const deleteByFilter = async (the_filter) => {

    say("deleteByFilter", the_filter)

    const filesToDelete = await filterByObj(the_filter)

    const howMany = filesToDelete.length

    say("deleting", filesToDelete)

    try {
      filesToDelete.forEach(file => {
        del(file.id)
      })
    }
    catch (error) {
      console.error("deleteByFilter", error)
    }

    return howMany
  }


  const allFilesWithoutContent = async () => {

    const allFiles = []

    let cursor = await (await dbPromise).transaction("files").store.openCursor()

    while (cursor) {
      // console.log(cursor.key, cursor.value)

      const value = {
        id: cursor.value.id,
        mimetype: cursor.value.mimetype,
        extension: cursor.value.extension,
        created_at: cursor.value.created_at,
        name: cursor.value.name,
        size: cursor.value.size,
        target_uuid: cursor.value.target_uuid,
        state: cursor.value.state,
        purpose: cursor.value.purpose,
        // no content
      }
      allFiles.push(value)
      cursor = await cursor.continue()
    }

    // sort by created_at

    allFiles.sort((a, b) => {
      return b?.created_at - a?.created_at
    })


    return allFiles
  }


  const allFiles = async () => {

    const allFiles = []

    let cursor = await (await dbPromise).transaction("files").store.openCursor()

    while (cursor) {
      // console.log(cursor.key, cursor.value)
      allFiles.push(cursor.value)
      cursor = await cursor.continue()
    }

    // sort by created_at

    allFiles.sort((a, b) => {
      return b?.created_at - a?.created_at
    })

    return allFiles
  }



  const count = async () => {
    let keys = await (await dbPromise).transaction("files").store.getAllKeys()
    return keys.length
  }

  return {

    add,
    get,
    set,
    del,
    clear,
    keys,
    keysByFileType,
    filterByObj,
    deleteByFilter,
    allFilesWithoutContent,
    allFiles, // dump purpose only
    updatedSomeValues,
    count,
    // keysByFilter,
  }

})

